import React, { useState, useEffect, useRef } from 'react';
import { FaTimes, FaPhone, FaUser, FaChevronRight, FaChevronDown, FaInfoCircle } from 'react-icons/fa';
import { useLanguage } from './LanguageContext';
import { sendContactData } from './services/contactService';
import Snackbar from './Snackbar';
import './ProductModal.css';

const ProductModal = ({ isOpen, onClose, product }) => {
    const { t, language } = useLanguage();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        selectedSize: '',
        customSize: ''
    });
    const [isCustomSize, setIsCustomSize] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [phoneValid, setPhoneValid] = useState(false);
    const [showSpecs, setShowSpecs] = useState(false);
    const [snackbar, setSnackbar] = useState({
        isOpen: false,
        message: '',
        type: 'success'
    });

    // === НОВАЯ ХУЙНЯ ДЛЯ ВЫПАДАЮЩЕГО СПИСКА ===
    const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // === НОВАЯ, СУКА, МАГИЯ. ОПРЕДЕЛЯЕМ НАПРАВЛЕНИЕ ===
    const [dropdownDirection, setDropdownDirection] = useState('down'); // 'up' или 'down'
    const dropdownSelectRef = useRef(null); // Реф для самого селекта, чтобы измерить его
    // ===============================================

    // === НОВАЯ, СУКА, МАГИЯ. ПРЯЧЕМ ВИДЖЕТЫ ===
    useEffect(() => {
        // Находим контейнер с плавающими кнопками
        const floatingContainer = document.getElementById('floating-actions-container-id');
        if (isOpen) {
            // Если модалка открыта, прячем нахуй кнопки
            if (floatingContainer) floatingContainer.style.display = 'none';
        } else {
            // Если модалка закрыта, показываем их обратно
            if (floatingContainer) floatingContainer.style.display = 'flex';
        }

        // Эта функция очистки сработает, когда компонент исчезнет, 
        // и вернет кнопки, если модалка была закрыта аварийно
        return () => {
            if (floatingContainer) floatingContainer.style.display = 'flex';
        };
    }, [isOpen]); // <-- Эта магия, блять, зависит только от того, открыта модалка или нет
    // ===========================================


    // Очищаем форму каждый раз при открытии нового продукта
    useEffect(() => {
        if (isOpen) {
            setFormData({
                name: '',
                phone: '',
                selectedSize: '',
                customSize: ''
            });
            setPhoneValid(false);
            setShowSpecs(false);
            setIsSizeDropdownOpen(false); // Закрываем дропдаун при открытии
            setIsCustomSize(false);
        }
    }, [isOpen, product]);

    // === useEffect, ЧТОБЫ ЗАКРЫВАТЬ СПИСОК ПО КЛИКУ МИМО ===
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsSizeDropdownOpen(false);
            }
        };
        if (isSizeDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSizeDropdownOpen]);
    // ========================================================

    // ТВОИ СТАНДАРТНЫЕ РАЗМЕРЫ, КАК ТЫ И ПРОСИЛ
    const mattressSizes = [
        '90x200 см',
        '100x200 см',
        '120x200 см',
        '140x200 см',
        '160x200 см',
        '180x200 см',
        '200x200 см'
    ];

    const validatePhone = (phone) => {
        const cleanPhone = phone.replace(/[\s\-()]/g, '');
        const phoneRegex = /^\+7[0-9]{10}$/;
        if (cleanPhone.startsWith('7') && cleanPhone.length === 11) return true;
        if (cleanPhone.startsWith('8') && cleanPhone.length === 11) return true;
        return phoneRegex.test(cleanPhone);
    };

    const formatPhoneMask = (value) => {
        const numbers = value.replace(/\D/g, '');
        let cleanNumbers = numbers;
        if (cleanNumbers.startsWith('8')) cleanNumbers = '7' + cleanNumbers.substring(1);
        if (cleanNumbers.startsWith('7')) cleanNumbers = '+' + cleanNumbers;
        if (cleanNumbers.length > 12) cleanNumbers = cleanNumbers.substring(0, 12);

        if (cleanNumbers.startsWith('+7')) {
            const digits = cleanNumbers.substring(2);
            let formatted = '+7';
            if (digits.length > 0) formatted += ' (' + digits.substring(0, 3);
            if (digits.length > 3) formatted += ') ' + digits.substring(3, 6);
            if (digits.length > 6) formatted += ' - ' + digits.substring(6, 8);
            if (digits.length > 8) formatted += ' - ' + digits.substring(8, 11);
            return formatted;
        }
        return cleanNumbers;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phone') {
            const formattedPhone = formatPhoneMask(value);
            const isValid = validatePhone(formattedPhone);
            setPhoneValid(isValid);
            setFormData(prev => ({ ...prev, [name]: formattedPhone }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // === НОВАЯ, СУКА, МАГИЯ. ОПРЕДЕЛЯЕМ НАПРАВЛЕНИЕ ===
    const handleDropdownToggle = () => {
        // Когда мы открываем список
        if (!isSizeDropdownOpen) {
            const selectElement = dropdownSelectRef.current;
            if (selectElement) {
                const rect = selectElement.getBoundingClientRect(); // Получаем его координаты
                const spaceBelow = window.innerHeight - rect.bottom; // Считаем место внизу
                const estimatedDropdownHeight = 200; // Примерная высота нашего списка в px

                // Если места внизу, блять, не хватает - открываем вверх
                if (spaceBelow < estimatedDropdownHeight) {
                    setDropdownDirection('up');
                } else {
                    setDropdownDirection('down');
                }
            }
        }
        setIsSizeDropdownOpen(!isSizeDropdownOpen);
    };

    // Новая функция для выбора размера из дропдауна
    const handleSizeSelect = (size) => {
        if (size === t('productModalOtherSize')) {
            // Если выбран "Другой размер"
            setIsCustomSize(true);
            setFormData(prev => ({ ...prev, selectedSize: t('productModalOtherSize'), customSize: '' }));
        } else {
            // Если выбран обычный размер
            setIsCustomSize(false);
            setFormData(prev => ({ ...prev, selectedSize: size, customSize: '' }));
        }
        setIsSizeDropdownOpen(false); // Закрываем список после выбора
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) {
            setSnackbar({ isOpen: true, message: t('productModalNameRequired'), type: 'error' });
            return;
        }
        if (!formData.phone.trim()) {
            setSnackbar({ isOpen: true, message: t('productModalPhoneRequired'), type: 'error' });
            return;
        }
        if (!formData.selectedSize) {
            setSnackbar({ isOpen: true, message: t('productModalSizeRequired'), type: 'error' });
            return;
        }
        // Проверяем, если выбран "Другой размер", то должен быть введен кастомный размер
        if (isCustomSize && !formData.customSize.trim()) {
            setSnackbar({ isOpen: true, message: t('productModalCustomSizeRequired'), type: 'error' });
            return;
        }
        if (!validatePhone(formData.phone)) {
            setSnackbar({ isOpen: true, message: t('productModalPhoneInvalid'), type: 'error' });
            return;
        }

        setIsSubmitting(true);

        setTimeout(() => {
            setSnackbar({ isOpen: true, message: t('productModalSuccessMessage'), type: 'success' });
            setIsSubmitting(false);

            setTimeout(() => {
                onClose();
            }, 2000);
        }, 1000);

        try {
            const fullProductName = `${product?.category || ''} ${product?.title || product?.name || ''}`.trim();

            const productFeatures = [];
            if (product?.construction) productFeatures.push(`Конструкция: ${product.construction}`);
            if (product?.filler) productFeatures.push(`Наполнитель: ${product.filler}`);
            if (product?.side1) productFeatures.push(`1-ая сторона: ${product.side1}`);
            if (product?.side2) productFeatures.push(`2-ая сторона: ${product.side2}`);
            if (product?.cover) productFeatures.push(`Чехол: ${product.cover}`);
            if (product?.height) productFeatures.push(`Высота: ${product.height}`);
            if (product?.stiffness) productFeatures.push(`Жесткость: ${product.stiffness}`);
            if (product?.load) productFeatures.push(`Нагрузка на 1 место: ${product.load}`);
            if (product?.springs) productFeatures.push(`Пружин на 1 место: ${product.springs}`);
            if (product?.warranty) productFeatures.push(`Гарантия: ${product.warranty}`);
            if (product?.features) productFeatures.push(`Особенности: ${product.features}`);
            if (product?.frame) productFeatures.push(`Каркас: ${product.frame}`);
            if (product?.orthopedicEffect) productFeatures.push(`Ортопедический эффект: ${product.orthopedicEffect}`);

            // Определяем финальный размер для отправки
            const finalSize = isCustomSize && formData.customSize.trim()
                ? formData.customSize.trim()
                : formData.selectedSize;

            const contactData = {
                ...formData,
                source: 'product-modal',
                language: language,
                productName: fullProductName,
                productSize: finalSize,
                productFeatures: productFeatures,
                productDescription: product?.description || '',
                mattress: fullProductName,
                size: finalSize,
            };

            sendContactData(contactData)
                .then(result => {
                    // Данные отправлены
                })
                .catch(error => {
                });

        } catch (error) {
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, isOpen: false }));
    };

    const toggleSpecs = () => {
        setShowSpecs(!showSpecs);
    };

    if (!isOpen || !product) {
        return null;
    }

    const productFeaturesForDisplay = [];
    if (product?.construction) productFeaturesForDisplay.push(`${t('constructionType', 'Конструкция')}: ${product.construction}`);
    if (product?.filler) productFeaturesForDisplay.push(`${t('filler', 'Наполнитель')}: ${product.filler}`);
    if (product?.side1) productFeaturesForDisplay.push(`${t('side1', '1-ая сторона')}: ${product.side1}`);
    if (product?.side2) productFeaturesForDisplay.push(`${t('side2', '2-ая сторона')}: ${product.side2}`);
    if (product?.cover) productFeaturesForDisplay.push(`${t('cover', 'Чехол')}: ${product.cover}`);
    if (product?.height) productFeaturesForDisplay.push(`${t('height', 'Высота')}: ${product.height}`);
    if (product?.stiffness) productFeaturesForDisplay.push(`${t('stiffness', 'Жесткость')}: ${product.stiffness}`);
    if (product?.load) productFeaturesForDisplay.push(`${t('maxLoad', 'Нагрузка на 1 место')}: ${product.load}`);
    if (product?.springs) productFeaturesForDisplay.push(`${t('springs', 'Пружин на 1 место')}: ${product.springs}`);
    if (product?.warranty) productFeaturesForDisplay.push(`${t('warranty', 'Гарантия')}: ${product.warranty}`);
    if (product?.features) productFeaturesForDisplay.push(`${t('features', 'Особенности')}: ${product.features}`);
    if (product?.frame) productFeaturesForDisplay.push(`${t('frame', 'Каркас')}: ${product.frame}`);
    if (product?.orthopedicEffect) productFeaturesForDisplay.push(`${t('orthopedicEffect', 'Ортопедический эффект')}: ${product.orthopedicEffect}`);

    const fullProductName = `${product.category || ''} ${product.title || ''}`.trim();
    const mainImage = Array.isArray(product.image) ? product.image[0] : product.image;

    return (
        <>
            <div className="product-modal-overlay" onClick={onClose}>
                <div className="product-modal" onClick={(e) => e.stopPropagation()}>
                    <button className="modal-close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>

                    <div className="modal-content">
                        <div className="modal-image-section">
                            {mainImage ? (
                                <img src={mainImage} alt={fullProductName} className="modal-product-image" />
                            ) : (
                                <div className="modal-image-placeholder">
                                    <span>Нет изображения</span>
                                </div>
                            )}
                        </div>

                        <div className="modal-title-section">
                            <h2 className="modal-product-name">{fullProductName}</h2>
                        </div>



                        <div className="modal-specs-section">
                            <div className="specs-toggle-container">
                                <button
                                    className="specs-toggle-btn"
                                    onClick={toggleSpecs}
                                    type="button"
                                >
                                    <FaInfoCircle className="specs-icon" />
                                    <span className="specs-toggle-text">
                                        {showSpecs ? 'Скрыть характеристики' : 'Показать характеристики'}
                                    </span>
                                    {showSpecs ? <FaChevronDown className="specs-chevron" /> : <FaChevronRight className="specs-chevron" />}
                                </button>
                            </div>

                            {showSpecs && productFeaturesForDisplay.length > 0 && (
                                <div className="modal-specs specs-content">
                                    <div className="main-features">
                                        {productFeaturesForDisplay.map((feature, index) => (
                                            <div key={index} className="feature-item">
                                                {feature}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="modal-order-form">
                            <h3>{t('productModalTitle')}</h3>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name"><FaUser /> {t('productModalNameLabel')}</label>
                                    <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} placeholder={t('productModalNamePlaceholder')} required />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phone">
                                        <FaPhone /> {t('productModalPhoneLabel')}
                                        {formData.phone && (<span className={`phone-status ${phoneValid ? 'valid' : 'invalid'}`}>{phoneValid ? '✓' : '✗'}</span>)}
                                    </label>
                                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder={t('productModalPhonePlaceholder')} className={formData.phone ? (phoneValid ? 'phone-valid' : 'phone-invalid') : ''} required />
                                    {formData.phone && !phoneValid && (<div className="phone-error-message">{t('productModalPhoneError')}</div>)}
                                </div>

                                {/* === ИСПРАВЛЕННЫЙ, СУКА, БЛОК ВЫБОРА РАЗМЕРА === */}
                                <div className="form-group" ref={dropdownRef}>
                                    <label>{t('productModalSizeLabel')}</label>
                                    <div className="custom-dropdown">
                                        <div
                                            ref={dropdownSelectRef}
                                            className={`dropdown-selected ${isSizeDropdownOpen ? 'open' : ''}`}
                                            onClick={handleDropdownToggle}
                                        >
                                            {formData.selectedSize || t('productModalSelectSizePlaceholder') || 'Выберите размер'}
                                            <FaChevronDown className={`dropdown-chevron ${isSizeDropdownOpen ? 'open' : ''}`} />
                                        </div>
                                        {isSizeDropdownOpen && (
                                            <div className={`dropdown-options ${dropdownDirection === 'up' ? 'up' : ''}`}>
                                                {/* ИСПОЛЬЗУЕМ СТАНДАРТНЫЙ МАССИВ РАЗМЕРОВ БЕЗ ЦЕН */}
                                                {mattressSizes.map((size) => (
                                                    <div
                                                        key={size}
                                                        className="dropdown-option"
                                                        onClick={() => handleSizeSelect(size)}
                                                    >
                                                        <span className="option-size">{size}</span>
                                                    </div>
                                                ))}
                                                {/* Опция "Другой размер" */}
                                                <div
                                                    className="dropdown-option dropdown-option-other"
                                                    onClick={() => handleSizeSelect(t('productModalOtherSize'))}
                                                >
                                                    <span className="option-size">{t('productModalOtherSize')}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* Поле для ввода кастомного размера, показывается только если выбран "Другой размер" */}
                                    {isCustomSize && (
                                        <div className="custom-size-input" style={{ marginTop: '15px' }}>
                                            <label>{t('productModalCustomSizeLabel')}</label>
                                            <input
                                                type="text"
                                                value={formData.customSize}
                                                onChange={(e) => setFormData(prev => ({ ...prev, customSize: e.target.value }))}
                                                placeholder={t('productModalCustomSizePlaceholder')}
                                                className="custom-size-field"
                                            />
                                        </div>
                                    )}
                                </div>
                                {/* ============================================= */}

                                <button type="submit" className="modal-submit-btn" disabled={isSubmitting}>
                                    {isSubmitting ? t('productModalSubmitting') : t('productModalSubmitButton')}
                                    <FaChevronRight />
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <Snackbar
                isOpen={snackbar.isOpen}
                message={snackbar.message}
                type={snackbar.type}
                onClose={handleCloseSnackbar}
                duration={5000}
            />
        </>
    );
};

export default ProductModal;